// Generated by ReScript, PLEASE EDIT WITH CARE


var getOffsetTop = (id => document.querySelector(id).offsetTop);

function scrollToElement(id) {
  var match = document.querySelector(id);
  if (!(match == null)) {
    window.scrollTo({
          top: getOffsetTop(id),
          behavior: "smooth"
        });
    return ;
  }
  
}

var $$Window = {
  getOffsetTop: getOffsetTop,
  scrollToElement: scrollToElement
};

var setTitle = (title => document.title = title);

var addHtmlClass = ((cl) => document.documentElement.classList.add(cl));

var removeHtmlClass = ((cl) => document.documentElement.classList.remove(cl));

var $$Document = {
  setTitle: setTitle,
  addHtmlClass: addHtmlClass,
  removeHtmlClass: removeHtmlClass
};

export {
  $$Window ,
  $$Document ,
}
/* No side effect */
